{
  "shellSkipMenuMainContent": "Pular para o conteúdo principal"
}
